var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlechaInactivo24X24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2929 13.9514C12.1243 14.0958 11.8757 14.0958 11.7072 13.9514L5.48811 8.62076C5.17361 8.35119 4.70014 8.38761 4.43057 8.70211C4.161 9.0166 4.19743 9.49007 4.51192 9.75964L10.731 15.0903C11.4612 15.7162 12.5388 15.7162 13.2691 15.0903L19.4881 9.75964C19.8026 9.49008 19.839 9.0166 19.5695 8.70211C19.2999 8.38761 18.8264 8.35119 18.5119 8.62076L12.2929 13.9514Z",
    fill: "#88919E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaInactivo24X24);
export default __webpack_public_path__ + "static/media/FLECHA_INACTIVO_24X24.349546247d0ef379bb521a03891adb95.svg";
export { ForwardRef as ReactComponent };